import { useContext } from 'react';

import { ThemeModeContext, ThemeModeContextValue } from './ThemeModeContext';

export default function useThemeMode(): ThemeModeContextValue {
  const context = useContext(ThemeModeContext);

  if (!context) {
    throw new Error('useThemeMode must be used within a ThemeModeProvider');
  }

  return context;
}
